import marks from "./marks.json";

export function WorkspaceLogo({ name, logo }: { name?: string; logo?: string | null }) {
	if (logo) return <img className="top-logo" src={logo} alt="" />;
	const key = (name ?? "").trim().toLowerCase();
	if (key === "cucius") {
		return (
			<svg className="top-logo" viewBox="0 0 156.79 164.51" fill="none" role="img" aria-label="Cucius">
				<path fill="currentColor" fillRule="evenodd" d={marks.cucius} />
			</svg>
		);
	}
	if (key === "jages") {
		return (
			<svg className="top-logo" viewBox="0 0 32.1 28" fill="none" role="img" aria-label="Jages">
				<path fill="currentColor" fillRule="evenodd" d={marks.jages} />
			</svg>
		);
	}
	return null;
}
